import React from 'react';
import { credentials } from '../../data/mock';

export const CredentialsBar = () => (
  <div className="valuare-cred-bar" data-testid="credentials-bar">
    {credentials.map((cred) => (
      <span key={cred.id} className="valuare-cred-item">
        {cred.icon} {cred.label}
      </span>
    ))}
  </div>
);
